module.exports = __webpack_public_path__ + "img/side-icon-22-off.b0f104f1.svg";